import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

// Calendar Icon - from Figma S2_Icon_Calendar_20_N (exact Figma extraction)
export const S2_Icon_Calendar_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#EF5A98', // Figma magenta color for scheduled milestones
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.4502 1.8H8.2502V1.2C8.2502 0.951564 8.04863 0.75 7.8002 0.75C7.55176 0.75 7.3502 0.951564 7.3502 1.2V1.8H4.6502V1.2C4.6502 0.951564 4.44863 0.75 4.2002 0.75C3.95176 0.75 3.7502 0.951564 3.7502 1.2V1.8H2.5502C1.80576 1.8 1.2002 2.40586 1.2002 3.15V9.45C1.2002 10.1941 1.80576 10.8 2.5502 10.8H9.4502C10.1946 10.8 10.8002 10.1941 10.8002 9.45V3.15C10.8002 2.40586 10.1946 1.8 9.4502 1.8ZM2.5502 2.7H3.7502V3C3.7502 3.24844 3.95176 3.45 4.2002 3.45C4.44863 3.45 4.6502 3.24844 4.6502 3V2.7H7.3502V3C7.3502 3.24844 7.55176 3.45 7.8002 3.45C8.04863 3.45 8.2502 3.24844 8.2502 3V2.7H9.4502C9.69834 2.7 9.9002 2.90215 9.9002 3.15V4.2H2.1002V3.15C2.1002 2.90215 2.30205 2.7 2.5502 2.7ZM9.4502 9.9H2.5502C2.30205 9.9 2.1002 9.69785 2.1002 9.45V5.1H9.9002V9.45C9.9002 9.69785 9.69834 9.9 9.4502 9.9Z"
      fill={color}
    />
    <path
      d="M4.2 6.6C4.2 6.26863 3.93137 6 3.6 6C3.26863 6 3 6.26863 3 6.6C3 6.93137 3.26863 7.2 3.6 7.2C3.93137 7.2 4.2 6.93137 4.2 6.6Z"
      fill={color}
    />
    <path
      d="M6.5999 6.6C6.5999 6.26863 6.33127 6 5.9999 6C5.66853 6 5.3999 6.26863 5.3999 6.6C5.3999 6.93137 5.66853 7.2 5.9999 7.2C6.33127 7.2 6.5999 6.93137 6.5999 6.6Z"
      fill={color}
    />
    <path
      d="M8.9998 6.6C8.9998 6.26863 8.73118 6 8.3998 6C8.06843 6 7.7998 6.26863 7.7998 6.6C7.7998 6.93137 8.06843 7.2 8.3998 7.2C8.73118 7.2 8.9998 6.93137 8.9998 6.6Z"
      fill={color}
    />
    <path
      d="M4.2 8.3998C4.2 8.06843 3.93137 7.7998 3.6 7.7998C3.26863 7.7998 3 8.06843 3 8.3998C3 8.73118 3.26863 8.9998 3.6 8.9998C3.93137 8.9998 4.2 8.73118 4.2 8.3998Z"
      fill={color}
    />
    <path
      d="M6.5999 8.3998C6.5999 8.06843 6.33127 7.7998 5.9999 7.7998C5.66853 7.7998 5.3999 8.06843 5.3999 8.3998C5.3999 8.73118 5.66853 8.9998 5.9999 8.9998C6.33127 8.9998 6.5999 8.73118 6.5999 8.3998Z"
      fill={color}
    />
    <path
      d="M8.9998 8.3998C8.9998 8.06843 8.73118 7.7998 8.3998 7.7998C8.06843 7.7998 7.7998 8.06843 7.7998 8.3998C7.7998 8.73118 8.06843 8.9998 8.3998 8.9998C8.73118 8.9998 8.9998 8.73118 8.9998 8.3998Z"
      fill={color}
    />
  </svg>
);

// Email Icon - from Figma S2_Icon_Email_20_N (exact Figma extraction)
export const S2_Icon_Email_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#147AF3', // Figma blue color for email communications
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.0501 1.7959H1.9501C1.20596 1.7959 0.600098 2.40176 0.600098 3.1459V8.8459C0.600098 9.59004 1.20596 10.1959 1.9501 10.1959H10.0501C10.7942 10.1959 11.4001 9.59004 11.4001 8.8459V3.1459C11.4001 2.40176 10.7942 1.7959 10.0501 1.7959ZM9.79771 2.6959L6.29541 5.7457C6.12783 5.89219 5.87295 5.89219 5.7042 5.7457L2.20249 2.6959H9.79771ZM10.0501 9.2959H1.9501C1.70224 9.2959 1.5001 9.09375 1.5001 8.8459V3.27715L5.11299 6.42422C5.36611 6.64453 5.68311 6.75469 6.0001 6.75469C6.31709 6.75469 6.63408 6.64453 6.88662 6.42422L10.5001 3.27715V8.8459C10.5001 9.09375 10.298 9.2959 10.0501 9.2959Z"
      fill={color}
    />
  </svg>
);

// Video Icon - from Figma S2_Icon_Video_20_N (exact Figma extraction)
export const S2_Icon_Video_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#6D6D6D', // Figma gray color for recordings/video conferences
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.4502 10.8002H2.5502C1.80606 10.8002 1.2002 10.1943 1.2002 9.4502V2.5502C1.2002 1.80606 1.80606 1.2002 2.5502 1.2002H9.4502C10.1943 1.2002 10.8002 1.80606 10.8002 2.5502V9.4502C10.8002 10.1943 10.1943 10.8002 9.4502 10.8002ZM2.5502 2.1002C2.30234 2.1002 2.1002 2.30234 2.1002 2.5502V9.4502C2.1002 9.69805 2.30234 9.9002 2.5502 9.9002H9.4502C9.69805 9.9002 9.9002 9.69805 9.9002 9.4502V2.5502C9.9002 2.30234 9.69805 2.1002 9.4502 2.1002H2.5502Z"
      fill={color}
    />
    <path
      d="M7.84407 5.47162L5.08425 3.98835C4.68452 3.77351 4.2002 4.06305 4.2002 4.51686V7.4834C4.2002 7.9372 4.68452 8.22674 5.08425 8.01191L7.84408 6.52863C8.26535 6.30222 8.26535 5.69803 7.84407 5.47162Z"
      fill={color}
    />
  </svg>
);

// Refresh Icon - from Figma S2_Icon_Refresh_20_N (exact Figma extraction)
export const S2_Icon_Refresh_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#E46F00', // Figma orange color for rescheduled milestones
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.9238 2.33847C10.6807 2.28163 10.439 2.42871 10.3807 2.6707L10.1524 3.61552C9.3138 2.1564 7.75129 1.21289 5.99992 1.21289C3.78918 1.21289 1.87462 2.71289 1.34435 4.86094C1.28458 5.10234 1.43195 5.34609 1.67335 5.40586C1.91418 5.46562 2.15851 5.31797 2.21798 5.07656C2.64894 3.33164 4.20402 2.11289 5.99991 2.11289C7.51002 2.11289 8.84091 2.98066 9.48529 4.29228L8.22384 3.9873C7.98184 3.93105 7.73926 4.07754 7.68067 4.31953C7.62237 4.56093 7.77091 4.8041 8.01231 4.86269L9.95946 5.3332C10.0343 5.38637 10.1236 5.41875 10.2184 5.41875C10.2541 5.41875 10.2904 5.41464 10.3265 5.40586C10.3554 5.39868 10.378 5.38125 10.404 5.36923C10.4457 5.3581 10.49 5.35752 10.5275 5.33437C10.6291 5.27226 10.7021 5.17206 10.7302 5.05605L11.2555 2.88163C11.3138 2.64023 11.1652 2.39706 10.9238 2.33847Z"
      fill={color}
    />
    <path
      d="M10.3267 6.61915C10.0885 6.56115 9.84185 6.70704 9.78209 6.94845C9.35114 8.69396 7.79606 9.91271 6.00016 9.91271C4.48994 9.91271 3.15902 9.04479 2.51468 7.73259L3.77624 8.03771C4.01793 8.09279 4.2611 7.94748 4.3194 7.70548C4.3777 7.46408 4.22916 7.22091 3.98776 7.16232L2.0348 6.69035C1.93218 6.61945 1.80361 6.58752 1.6736 6.61916C1.66448 6.62151 1.658 6.62795 1.64918 6.63073C1.58725 6.63864 1.52682 6.65725 1.47263 6.69064C1.37097 6.75275 1.29801 6.85295 1.26989 6.96896L0.744598 9.14338C0.686296 9.38478 0.834832 9.62795 1.07624 9.68654C1.11198 9.69474 1.14743 9.69885 1.18229 9.69885C1.38532 9.69885 1.5696 9.56056 1.6194 9.35431L1.84766 8.40949C2.68625 9.86877 4.2488 10.8127 6.00017 10.8127C8.21091 10.8127 10.1255 9.31212 10.6557 7.16408C10.7155 6.92268 10.5681 6.67892 10.3267 6.61915Z"
      fill={color}
    />
  </svg>
);

// CheckmarkCircle Icon - from Figma S2_Icon_CheckmarkCircle_20_N
export const S2_Icon_CheckmarkCircle_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#292929',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 18.75C5.1748 18.75 1.25 14.8252 1.25 10C1.25 5.1748 5.1748 1.25 10 1.25C14.8252 1.25 18.75 5.1748 18.75 10C18.75 14.8252 14.8252 18.75 10 18.75ZM10 2.75C6.00195 2.75 2.75 6.00195 2.75 10C2.75 13.998 6.00195 17.25 10 17.25C13.998 17.25 17.25 13.998 17.25 10C17.25 6.00195 13.998 2.75 10 2.75Z"
      fill={color}
    />
    <path
      d="M9.22267 13.5C9.01076 13.5 8.80763 13.4102 8.66505 13.252L6.15431 10.46C5.87697 10.1514 5.90236 9.67773 6.20997 9.40039C6.51758 9.12305 6.99122 9.14844 7.26954 9.45605L9.16309 11.5625L12.6504 6.80664C12.8935 6.47266 13.3613 6.39746 13.6982 6.64551C14.0322 6.88965 14.1045 7.35938 13.8594 7.69336L9.82714 13.1934C9.69433 13.376 9.48534 13.4883 9.25976 13.499C9.24804 13.5 9.23537 13.5 9.22267 13.5Z"
      fill={color}
    />
  </svg>
);

// File Icon - from Figma S2_Icon_File_20_N
export const S2_Icon_File_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#292929',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.3413 5.28027L12.7192 1.65918C12.2944 1.23438 11.7295 1 11.1289 1H5.25C4.00928 1 3 2.00977 3 3.25V15.75C3 16.9902 4.00928 18 5.25 18H14.75C15.9907 18 17 16.9902 17 15.75V6.87109C17 6.27929 16.7603 5.69921 16.3413 5.28027ZM15.2803 6.34082C15.3259 6.38647 15.3541 6.44458 15.3863 6.5H12.25C11.8364 6.5 11.5 6.16309 11.5 5.75V2.61401C11.5552 2.64624 11.6132 2.67419 11.6587 2.71972L15.2803 6.34082ZM14.75 16.5H5.25C4.83643 16.5 4.5 16.1631 4.5 15.75V3.25C4.5 2.83691 4.83643 2.5 5.25 2.5H10V5.75C10 6.99023 11.0093 8 12.25 8H15.5V15.75C15.5 16.1631 15.1636 16.5 14.75 16.5Z"
      fill={color}
    />
  </svg>
);

// FileText Icon - from Figma S2_Icon_FileText_20_N
export const S2_Icon_FileText_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#292929',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.3408 5.2959L12.7197 1.67383C12.3008 1.25488 11.7207 1.01465 11.1289 1.01465H5.25C4.00977 1.01465 3 2.02442 3 3.26465V15.748C3 16.9883 4.00977 17.998 5.25 17.998H14.75C15.9902 17.998 17 16.9883 17 15.748V6.88672C17 6.28613 16.7656 5.7207 16.3408 5.2959ZM15.2803 6.35645C15.3264 6.40259 15.3542 6.45997 15.3862 6.51465H12.25C11.8369 6.51465 11.5 6.17774 11.5 5.76465V2.62842C11.5554 2.66065 11.6135 2.68872 11.6592 2.73438L15.2803 6.35645ZM14.75 16.498H5.25C4.83691 16.498 4.5 16.1611 4.5 15.748V3.26465C4.5 2.85156 4.83691 2.51465 5.25 2.51465H10V5.76465C10 7.00488 11.0098 8.01465 12.25 8.01465H15.5V15.748C15.5 16.1611 15.1631 16.498 14.75 16.498Z"
      fill={color}
    />
    <path
      d="M13 11.498H7C6.58594 11.498 6.25 11.1621 6.25 10.748C6.25 10.334 6.58594 9.99805 7 9.99805H13C13.4141 9.99805 13.75 10.334 13.75 10.748C13.75 11.1621 13.4141 11.498 13 11.498Z"
      fill={color}
    />
    <path
      d="M13 14.498H7C6.58594 14.498 6.25 14.1621 6.25 13.748C6.25 13.334 6.58594 12.998 7 12.998H13C13.4141 12.998 13.75 13.334 13.75 13.748C13.75 14.1621 13.4141 14.498 13 14.498Z"
      fill={color}
    />
  </svg>
);

// FileConvert Icon - from Figma S2_Icon_FileConvert_20_N
export const S2_Icon_FileConvert_20_N: React.FC<IconProps> = ({
  size = 20,
  color = '#292929',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.2803 12.5302L10.5303 14.2802C10.3838 14.4267 10.1919 14.5 9.99999 14.5C9.8081 14.5 9.6162 14.4267 9.46972 14.2802L7.71972 12.5302C7.42675 12.2373 7.42675 11.7627 7.71972 11.4697C8.01269 11.1767 8.4873 11.1767 8.78027 11.4697L9.20141 11.8908C9.16729 10.8759 8.70025 9.89718 7.87304 9.24752C6.35449 8.05465 4.15087 8.32125 2.95898 9.83834C2.64404 10.2397 2.42431 10.6928 2.30712 11.1845C2.21142 11.5874 1.80468 11.8364 1.40331 11.7397C1.00048 11.6435 0.751943 11.2387 0.848133 10.8359C1.0161 10.1328 1.32909 9.48531 1.77928 8.91207C3.48094 6.74312 6.63084 6.36519 8.79979 8.06783C10.019 9.02559 10.6981 10.4834 10.7066 11.9829L11.2197 11.4697C11.5127 11.1767 11.9873 11.1767 12.2803 11.4697C12.5732 11.7627 12.5732 12.2373 12.2803 12.5302ZM17 6.87106V15.75C17 16.9907 15.9907 18 14.75 18H5.24999C4.00927 18 2.99999 16.9907 2.99999 15.75V13.75C2.99999 13.3359 3.33593 13 3.74999 13C4.16405 13 4.49999 13.3359 4.49999 13.75V15.75C4.49999 16.1635 4.83642 16.5 5.24999 16.5H14.75C15.1636 16.5 15.5 16.1635 15.5 15.75V7.99997H12.25C11.0093 7.99997 9.99999 6.99069 9.99999 5.74997V2.49997H5.24999C4.83642 2.49997 4.49999 2.8364 4.49999 3.24997V4.74997C4.49999 5.16403 4.16405 5.49997 3.74999 5.49997C3.33593 5.49997 2.99999 5.16403 2.99999 4.74997V3.24997C2.99999 2.00925 4.00927 0.999969 5.24999 0.999969H11.1289C11.729 0.999969 12.2935 1.23386 12.7187 1.65817L16.3413 5.28073C16.7661 5.70651 17 6.27096 17 6.87106ZM12.25 6.49997H15.3862C15.3541 6.44467 15.3259 6.38657 15.2803 6.34079L11.6587 2.71921C11.6132 2.6738 11.5552 2.64572 11.5 2.61374V5.74997C11.5 6.16354 11.8364 6.49997 12.25 6.49997Z"
      fill={color}
    />
  </svg>
);

// Icon mapping for milestone status
export const MilestoneIcons = {
  calendar: S2_Icon_Calendar_20_N,
  email: S2_Icon_Email_20_N,
  video: S2_Icon_Video_20_N,
  refresh: S2_Icon_Refresh_20_N,
  checkmark: S2_Icon_CheckmarkCircle_20_N,
  file: S2_Icon_File_20_N,
  fileText: S2_Icon_FileText_20_N,
  fileConvert: S2_Icon_FileConvert_20_N,
  none: () => null
};
